'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/payment-pages/advertisment.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _level = require('@marmalade/bling/lib/level');
var _level2 = _interopRequireDefault(_level);
var _secondaryCopy = require('@marmalade/bling/lib/order-status/secondary-copy');
var _secondaryCopy2 = _interopRequireDefault(_secondaryCopy);
var _secondaryBackground = require('@marmalade/bling/lib/order-status/secondary-background');
var _secondaryBackground2 = _interopRequireDefault(_secondaryBackground);
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _grid = require('@marmalade/grid');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _icon = require('@marmalade/icon');
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
Advertisment.propTypes = {
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    icon: _propTypes.string,
    heading: _propTypes.string,
    body: _propTypes.string,
    cta: (0, _propTypes.shape)({
      link: _propTypes.string,
      text: _propTypes.string
    })
  }))
};
var Icon = (0, _glamorous2.default)(_icon.LargePrimaryIcon)(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.space_md + ' 0'
  };
});
function Advertisment(_ref2) {
  var _this = this;
  var data = _ref2.data,
    container = _ref2.container;
  var Element = container ? _grid.Container : _react.Fragment;
  return _react2.default.createElement(_secondaryBackground2.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: this
  }, _react2.default.createElement(Element, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: this
  }, _react2.default.createElement(_level2.default, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34
    },
    __self: this
  }, data.map(function (_ref3) {
    var icon = _ref3.icon,
      heading = _ref3.heading,
      body = _ref3.body,
      cta = _ref3.cta;
    return _react2.default.createElement(_glamorous.Div, {
      key: icon,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 350,
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '3rem',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36
      },
      __self: _this
    }, _react2.default.createElement(_glamorous.Div, {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      marginBottom: '.6rem',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45
      },
      __self: _this
    }, _react2.default.createElement(Icon, {
      type: icon,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52
      },
      __self: _this
    }), _react2.default.createElement(_glamorous.H3, {
      fontSize: '2.2rem',
      marginBottom: '.6rem',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53
      },
      __self: _this
    }, heading), _react2.default.createElement(_secondaryCopy2.default, {
      fontSize: '1.8rem',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56
      },
      __self: _this
    }, body)), _react2.default.createElement(_glamorous.Div, {
      maxWidth: '24rem',
      width: '100%',
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58
      },
      __self: _this
    }, _react2.default.createElement(_button2.default, {
      Element: 'a',
      href: cta.link,
      prominence: 'primary',
      block: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59
      },
      __self: _this
    }, cta.text)));
  }))));
}
exports.default = Advertisment;